module.exports = require('./helpers/bundle-url').getBundleURL('bRDu3') + "spritesheet.1ea11ac4.png";